module.exports = __webpack_public_path__ + "img/chevron-up.8c886faa.svg";